"use client";

import { Calendar, ArrowUpRight } from "lucide-react";

export function ConciergeBooking() {
    return (
        <div className="relative group overflow-hidden rounded-3xl border border-border/50 bg-card/60 backdrop-blur-md p-8 transition-all hover:bg-card/80">
            <div className="absolute inset-0 bg-linear-to-b from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            
            <div className="relative z-10 flex flex-col items-start gap-6">
                <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-blue-500/10 border border-blue-500/20 text-blue-400">
                    <Calendar className="w-7 h-7" />
                </div>
                
                <div className="space-y-3">
                    <h3 className="text-2xl font-semibold text-foreground tracking-tight">
                        Strategy Session
                    </h3>
                    <p className="text-muted-foreground leading-relaxed text-lg">
                        Skip the emails. Book a direct Architecture Discovery session to discuss your architecture, strategy, and business objectives.
                    </p>
                </div>

                <a 
                    href="https://cal.com/hamid-ayub/discovery"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-8 py-4 mt-2 rounded-full bg-slate-100 text-slate-900 hover:bg-white transition-colors font-semibold text-sm group/btn shadow-[0_0_15px_rgba(255,255,255,0.1)]"
                >
                    Select Available Time
                    <ArrowUpRight className="w-4 h-4 text-slate-500 transition-transform group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5" />
                </a>
            </div>
        </div>
    );
}
